import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Axios from 'axios'
import VueI18n from 'vue-i18n'
import ElementUI, {Loading} from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import {JSEncrypt} from 'jsencrypt'
import {DingTalkLogin} from '@/utils/dingTalkLogin';
import VueCookies from 'vue-cookies';
import './styles/index.scss'

Vue.use(VueI18n); // 通过插件的形式挂载
Vue.use(ElementUI);
Vue.use(Loading);
Vue.use(VueCookies)

Vue.config.productionTip = false;
Vue.prototype.$http = Axios;

//设置国际化
// let i18nJson = {lang: "zh_CN", messages: JSON.parse(localStorage.getItem("global-portal_i18n")).messages};
let i18nJson = ytg_i18n("global-portal");
let lang = i18nJson.lang;
let messages = i18nJson.messages;
const i18n = new VueI18n({
    locale: lang,
    fallbackLocale: 'zh_CN',
    messages,
    silentTranslationWarn: true
});

let vm = new Vue({
    el: '#app',
    i18n,
    router,
    store,
    components: {App},
    template: '<App/>'
});
